import { Checkbox, Grid, Tooltip } from "@mui/material";
import React, { useCallback } from "react";
import { toAbsoluteUrl } from '../../../infofleet/utils/utils';

function TopBarFilter(props) {
  const {
    livepanelfilter,
    livepanelclick,
    filterCount,
    locationfilter,
    fullscreen,
    vehicletypeBike,
    vehicletypeOthers,
  } = props;

  // ✅ Stable handler (prevents recreation every render)
  const handleChange = useCallback(
    (e, type) => livepanelclick(e, type),
    [livepanelclick]
  );

  return (
    <div className={fullscreen === 1 ? "fullscreen_status_icons_area" : "liveviewicons"}>
      {/* Move Count Filter */}
      <Grid item className="liveview_topbar_filtersection">
        <Tooltip title="Moving" placement={fullscreen === 1 ? "top" : "bottom"}>
          <div className="liveviewicons_section lv_move">
            <img
              alt=""
              src={
                fullscreen === 1
                  ? toAbsoluteUrl(
                      `/media/icons/LiveViewCar/TVview/${vehicletypeBike.length > 0 && vehicletypeOthers === 0
                        ? "tv_moving_bike.svg"
                        : "tv_moving.svg"}`
                    )
                  : toAbsoluteUrl("/media/icons/LiveViewCar/moving_car1.svg")
              }
            />
            <span className="topbar_count">
              {filterCount.movecount === undefined ? "0" : filterCount.movecount}
            </span>
            <Checkbox
              name="Moving"
              checked={livepanelfilter.Moving}
              onChange={(e) => handleChange(e, "Moving")}
              inputProps={{
                "aria-label": "primary checkbox",
              }}
              disabled={locationfilter === true}
            />
          </div>
        </Tooltip>
      </Grid>

      {/* Stopped Filter */}
      <Grid item className="liveview_topbar_filtersection">
        <Tooltip title="Stopped" placement={fullscreen === 1 ? "top" : "bottom"}>
          <div className="liveviewicons_section lv_stop">
            <img
              alt=""
              src={
                fullscreen === 1
                  ? toAbsoluteUrl(
                      `/media/icons/LiveViewCar/TVview/${vehicletypeBike.length > 0 && vehicletypeOthers === 0
                        ? "tv_stopped_bike.svg"
                        : "tv_stopped.svg"}`
                    )
                  : toAbsoluteUrl("/media/icons/LiveViewCar/stopped_car1.svg")
              }
            />
            <span className="topbar_count">
              {filterCount.Stoppedcount === undefined ? "0" : filterCount.Stoppedcount}
            </span>
            <Checkbox
              name="Stopped"
              checked={livepanelfilter.Stopped}
              onChange={(e) => handleChange(e, "Stopped")}
              inputProps={{
                "aria-label": "primary checkbox",
              }}
              disabled={locationfilter === true}
            />
          </div>
        </Tooltip>
      </Grid>

      {/* Parked Filter */}
      <Grid item className="liveview_topbar_filtersection">
        <Tooltip title="Parked" placement={fullscreen === 1 ? "top" : "bottom"}>
          <div className="liveviewicons_section lv_park">
            <img
              alt=""
              src={
                fullscreen === 1
                  ? toAbsoluteUrl(
                      `/media/icons/LiveViewCar/TVview/${vehicletypeBike.length > 0 && vehicletypeOthers === 0
                        ? "tv_parked_bike.svg"
                        : "tv_parked.svg"}`
                    )
                  : toAbsoluteUrl("/media/icons/LiveViewCar/parked_car1.svg")
              }
            />
            <span className="topbar_count">
              {filterCount.parkcount === undefined ? "0" : filterCount.parkcount}
            </span>
            <Checkbox
              name="Parked"
              checked={livepanelfilter.Parked}
              onChange={(e) => handleChange(e, "Parked")}
              inputProps={{
                "aria-label": "primary checkbox",
              }}
              disabled={locationfilter === true}
            />
          </div>
        </Tooltip>
      </Grid>

      {/* No Signal Filter */}
      <Grid item className="liveview_topbar_filtersection">
        <Tooltip title="No Signal" placement={fullscreen === 1 ? "top" : "bottom"}>
          <div className="liveviewicons_section lv_nosignal">
            <img
              alt=""
              src={
                fullscreen === 1
                  ? toAbsoluteUrl(
                      `/media/icons/LiveViewCar/TVview/${vehicletypeBike.length > 0 && vehicletypeOthers === 0
                        ? "tv_nosignal_bike.svg"
                        : "tv_nosignal.svg"}`
                    )
                  : toAbsoluteUrl("/media/icons/LiveViewCar/nosignal_car1.svg")
              }
            />
            <span className="topbar_count">
              {filterCount.noScount === undefined ? "0" : filterCount.noScount}
            </span>
            <Checkbox
              name="No Signal"
              checked={livepanelfilter.NoSignal}
              onChange={(e) => handleChange(e, "No Signal")}
              inputProps={{
                "aria-label": "primary checkbox",
              }}
              disabled={locationfilter === true}
            />
          </div>
        </Tooltip>
      </Grid>

      {/* Engine On Filter */}
      <Grid item className="liveview_topbar_filtersection">
        <Tooltip title="Idling Eng ON" placement={fullscreen === 1 ? "top" : "bottom"}>
          <div className="liveviewicons_section lv_engineOn">
            <img
              alt=""
              src={
                fullscreen === 1
                  ? toAbsoluteUrl(
                      `/media/icons/LiveViewCar/TVview/${vehicletypeBike.length > 0 && vehicletypeOthers === 0
                        ? "tv_engine_on_bike.svg"
                        : "tv_engine.svg"}`
                    )
                  : toAbsoluteUrl("/media/icons/LiveViewCar/engine_on.svg")
              }
            />
            <span className="topbar_count">
              {filterCount.Engineoncount === undefined ? "0" : filterCount.Engineoncount}
            </span>
            <Checkbox
              name="Engine ON"
              checked={livepanelfilter.Engineon}
              onChange={(e) => handleChange(e, "Engine ON")}
              inputProps={{
                "aria-label": "primary checkbox",
              }}
              disabled={locationfilter === true}
            />
          </div>
        </Tooltip>
      </Grid>
    </div>
  );
}

// Prevent re-render unless props actually change React.memo
export default React.memo(TopBarFilter);
